import * as React from "react";
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import LoadingFullScreen from "../../../components/LoadingFullScreen";
import { RootState, NavigationStep, CommunicationHistory, FamilyMember, Page } from "../../types";
import {
  getPatient,
  setPatientAndAct,
  deactivatePatient,
  getHistories,
  addFamilyMember,
  deleteFamilyMember,
  getMoreHistory
} from "../actions";
import "./Patient.scss";
import PatientDetail from "../components/PatientDetail";
import FamilyMembers from "../components/FamilyMembers";
import CommunicationHistoryDetail from "../components/CommunicationHistory";
import { User } from "../../session/types";
import { Patient } from "../types";
import { Organization } from "../../organizations/types";

interface StoreProps {
  user: User | null;
  loading: boolean;
  passiveLoading: boolean;
  patient: Patient | null;
  organization: Organization | null;
  histories: Page<CommunicationHistory> | null;
  familyMembers: Page<FamilyMember> | null;
}

interface DispatchProps {
  getPatient: (id: string) => void;
  setPatientAndAct: (patient: Patient, step: NavigationStep) => void;
  deactivatePatient: (patient: Patient) => void;
  getHistories: () => void;
  addFamilyMember: (familyMember: FamilyMember) => void;
  deleteFamilyMember: (familyMember: FamilyMember) => void;
  getMoreHistory: () => void;
}

interface OwnState {
  init: boolean;
}

type Props = OwnState & DispatchProps & StoreProps & RouteComponentProps<{ patientId: string }>;

class PatientDetailContainer extends React.PureComponent<Props, OwnState> {
  public constructor(props: Props) {
    super(props);

    this.state = {
      init: false
    };
  }

  public componentDidMount() {
    if (this.props.match.params.patientId) this.props.getPatient(this.props.match.params.patientId);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public componentDidUpdate(prevProps: any) {
    if (prevProps.patient !== this.props.patient) {
      this.setState({ init: true });
    }
  }

  public render() {
    const {
      passiveLoading,
      loading,
      patient,
      setPatientAndAct,
      deactivatePatient,
      histories,
      familyMembers,
      addFamilyMember,
      deleteFamilyMember,
      getMoreHistory,
      user,
      organization
    } = this.props;
    return (
      <>
        {loading && <LoadingFullScreen />}
        {passiveLoading && <LoadingFullScreen css="passive" />}
        {this.state.init && (
          <div className="patientDetailContainer mt-25">
            <div className="sections">
              <PatientDetail
                patient={patient}
                setPatientAndAct={setPatientAndAct}
                deactivatePatient={deactivatePatient}
                user={user}
                organization={organization}
              />
              <FamilyMembers
                familyMembers={familyMembers}
                addFamilyMember={addFamilyMember}
                deleteFamilyMember={deleteFamilyMember}
              />
              <CommunicationHistoryDetail histories={histories} getMoreHistory={getMoreHistory} />
            </div>
          </div>
        )}
      </>
    );
  }
}

export default connect<StoreProps, DispatchProps, {}, RootState>(
  state => ({
    user: state.session.data.currentUser,
    loading: state.patientdetail.loading,
    passiveLoading: state.patientdetail.passiveLoading,
    patient: state.patientdetail.data.patient,
    histories: state.patientdetail.data.histories,
    familyMembers: state.patientdetail.data.familyMembers,
    organization: state.orgs.currentOrganization
  }),
  {
    getPatient,
    setPatientAndAct,
    deactivatePatient,
    getHistories,
    addFamilyMember,
    deleteFamilyMember,
    getMoreHistory
  }
)(PatientDetailContainer);
